
// SESSIONS
export const GET_SESSIONS = "/sessions";
export const ADD_NEW_SESSION = "/sessions";
export const UPDATE_SESSION = "/sessions";
export const DELETE_SESSION = "/sessions";

export const GET_SESSION_RESULTS = "api/v1/session";


//export const PROCLAMER_SESSION = "api/v1/session/proclamer";
export const PROCLAMER_SESSION = "/proclamation-results";


export const GET_PROCLAMATION_RESULTS = "/proclamation-results";


export const GET_FINAL_DECISIONS = "/final-decisions";
export const SAVE_FINAL_DECISIONS = "/final-decisions";
export const RUN_ANNUAL_DELIBERATION= "/annual-deliberations";

